import type { BBox } from 'geojson';

/**
 * The `?bbox=` search param as a bounding box, or null when the value is not
 * one: not four finite numbers, or an inverted or zero-span box, which is not
 * a viewable extent. Longitudes beyond +/-180 are legitimate: the camera
 * publishes unwrapped bounds whenever the view crosses the antimeridian at low
 * zoom. Every consumer treats a null as "the URL carries no bbox".
 */
export function parseBboxParam(value: string | null): BBox | null {
  if (value == null || value.length === 0) {
    return null;
  }
  // An empty segment must not pass as a number: Number('') is 0, which would
  // silently relocate a truncated link's corner to the prime meridian.
  const parsed = value.split(',').map(part => (part.trim() === '' ? NaN : Number(part)));
  if (parsed.length !== 4 || !parsed.every(Number.isFinite)) {
    return null;
  }
  const [minLng, minLat, maxLng, maxLat] = parsed;
  if (minLng >= maxLng || minLat >= maxLat) {
    return null;
  }
  return [minLng, minLat, maxLng, maxLat];
}
